"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LabelTextInline;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function LabelTextInline(props) {
  var className = props.className,
    label = props.label,
    content = props.content;
  var contentModified;
  if (typeof content !== 'string') {
    if ((0, _lodash.isEmpty)(content)) {
      return null;
    }
    if (Array.isArray(content)) {
      contentModified = content.map(function (item) {
        return (0, _lodash.get)(item, 'displayName', '') || (0, _lodash.get)(item, 'name', '') || item;
      }).join(', ');
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('label-text-inline', className)
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "label-text-inline__label"
  }, label, ":"), "\xA0", /*#__PURE__*/_react["default"].createElement("span", null, contentModified || content));
}
LabelTextInline.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  /** Array or String, Object in array should be formatted like { name: value }, string is value, value, value */
  content: _propTypes["default"].any.isRequired
};
LabelTextInline.defaultProps = {
  className: ''
};